var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { on: { click: _vm.globalClick } },
    [
      _c("notification-bar", {
        attrs: {
          message: _vm.notification.message,
          onClose: _vm.onNotificationClose,
          show: _vm.notification.show,
          type: _vm.notification.type
        }
      }),
      _vm._v(" "),
      _c(
        "header",
        { staticClass: "top-bar" },
        [
          _c(
            "flex-grid",
            { attrs: { "align-items": "center", width: "100%" } },
            [
              _c("flex-grid-item", [
                _c("a", { staticClass: "logo", attrs: { href: "/domains" } }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.logo) } }),
                  _vm._v(" "),
                  _c("span", { staticClass: "version" }, [
                    _vm._v(_vm._s(_vm.version))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "feature-flag",
                { attrs: { name: "environmentSelect" } },
                [
                  _c(
                    "flex-grid-item",
                    [
                      _c("select-input", {
                        staticClass: "environment-select",
                        attrs: {
                          options: _vm.environment.list,
                          value: _vm.environment.value
                        },
                        on: { change: _vm.onEnvironmentSelectChange }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.$route.params.domain
                ? _c(
                    "flex-grid-item",
                    { attrs: { margin: "15px" } },
                    [
                      _c(
                        "flex-grid",
                        { attrs: { "align-items": "center" } },
                        [
                          _c(
                            "flex-grid-item",
                            [
                              !_vm.isSearchingDomain
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "workflows",
                                      attrs: {
                                        to: {
                                          name: "workflow-list",
                                          params: {
                                            clusterName:
                                              _vm.$route.params.clusterName
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$route.params.domain) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSearchingDomain
                                ? _c("domain-autocomplete", {
                                    attrs: {
                                      focus: true,
                                      height: "slim",
                                      width: "500px"
                                    },
                                    on: {
                                      onChange: _vm.onDomainAutocompleteChange
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "flex-grid-item",
                            [
                              _c("button-icon", {
                                attrs: {
                                  color: "primary",
                                  icon:
                                    "" +
                                    (_vm.isSearchingDomain
                                      ? "icon_delete"
                                      : "icon_search"),
                                  size: "18px",
                                  width: "22px"
                                },
                                on: { click: _vm.onEditDomainClick }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "flex-grid-item",
                            [
                              _c("active-status", {
                                attrs: {
                                  "cluster-name": _vm.$route.params.clusterName,
                                  domain: _vm.$route.params.domain,
                                  "workflow-id": _vm.$route.params.workflowId
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.workflowId
                ? _c("flex-grid-item", [
                    _c("span", [_vm._v(_vm._s(_vm.$route.params.workflowId))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.taskList
                ? _c("flex-grid-item", [
                    _c("span", [_vm._v(_vm._s(_vm.$route.params.taskList))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "flex-grid-item",
                { attrs: { grow: "1" } },
                [
                  _c("button-icon", {
                    staticStyle: { float: "right" },
                    attrs: {
                      color: "primary",
                      icon: "icon_settings",
                      label: "SETTINGS",
                      size: "30px"
                    },
                    on: { click: _vm.onSettingsClick }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "cross-region",
        [
          _c(
            "domain",
            [
              _c("router-view", {
                attrs: {
                  "date-format": _vm.settings.dateFormat,
                  "time-format": _vm.settings.timeFormat,
                  timezone: _vm.settings.timezone,
                  "workflow-history-event-highlight-list":
                    _vm.settings.workflowHistoryEventHighlightList,
                  "workflow-history-event-highlight-list-enabled":
                    _vm.settings.workflowHistoryEventHighlightListEnabled
                },
                on: {
                  onWorkflowHistoryEventParamToggle:
                    _vm.onWorkflowHistoryEventParamToggle,
                  onNotification: _vm.onNotification
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("modals-container"),
      _vm._v(" "),
      _c("v-dialog"),
      _vm._v(" "),
      _c("news-modal", {
        attrs: { "news-items": _vm.newsItems },
        on: { "before-close": _vm.onNewsDismiss }
      }),
      _vm._v(" "),
      _c("settings-modal", {
        attrs: {
          "date-format": _vm.settings.dateFormat,
          "date-format-options": _vm.settings.dateFormatOptions,
          "time-format": _vm.settings.timeFormat,
          "time-format-options": _vm.settings.timeFormatOptions,
          timezone: _vm.settings.timezone,
          "timezone-options": _vm.settings.timezoneOptions,
          "workflow-history-event-highlight-list":
            _vm.settings.workflowHistoryEventHighlightList,
          "workflow-history-event-highlight-list-enabled":
            _vm.settings.workflowHistoryEventHighlightListEnabled
        },
        on: { change: _vm.onSettingsChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-278f674b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-278f674b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue
// module id = 1697
// module chunks = 0